<template>
  <div>
    <!-- 面包屑 -->
    <bread-crumb path='内容管理' subPath='今日经文列表'></bread-crumb>
    <!-- 主体列表 -->
    <el-card>
      <el-row :gutter="20">
        <el-col :span="6">
          <el-button type="primary" @click="showAddDialog">添加今日经文</el-button>
        </el-col>
      </el-row>
      <el-table :data="lectionDayList" stripe border :cell-style="{ textAlign: 'center' }">
        <el-table-column prop="id" label="ID" align="center" width="50px"></el-table-column>
        <el-table-column label="日期" align="center">
          <template slot-scope="scope">
            {{scope.row.day_time*1000 | dateFormat}}
          </template>
        </el-table-column>
        <el-table-column prop="content" label="经文" align="center"></el-table-column>
        <el-table-column label="创建时间" align="center">
          <template slot-scope="scope">
            {{scope.row.create_time | dateTimeFormat}}
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="290px">
          <template slot-scope="scope">
            <el-button type="primary" icon="el-icon-edit" size="mini" @click="showEditDialog(scope.row.id)">编辑</el-button>
            <el-button type="danger" icon="el-icon-delete" size="mini" @click="deleteRow(scope.row.id)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="param.page"
        :page-sizes="[10, 20, 30, 40, 50]"
        :page-size="param.count"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </el-card>
    <lection-day-add :id="currentId"
      :visible="addDialogAvaible"
      @closeDialog="closeDialog"
      @update="updateLectionDay"
      @add="addLectionDay"></lection-day-add>
  </div>
</template>

<script>
import BreadCrumb from '../BreadCrumb.vue'
import LectionDayAdd from './LectionDayAdd.vue'
export default {
  name: 'lection_day_list',
  components: {
    'bread-crumb': BreadCrumb,
    'lection-day-add': LectionDayAdd
  },
  created () {
    this.getList()
  },
  data () {
    return {
      currentId: 0,
      lectionDayList: [],
      total: 0,
      pageTotal: 1,
      param: {
        keywords: '',
        page: 1,
        count: 10
      },
      addDialogAvaible: false
    }
  },
  methods: {
    async getList () {
      const res = await this.$http.get('/admin/lection_day/list', this.param)
      if (res.code === 0) {
        this.lectionDayList = res.data.list
        this.total = res.data.total
        this.pageTotal = res.data.total_page
      } else {
        this.$message.error(res.msg)
      }
    },
    handleSizeChange (size) {
      this.param.count = size
      this.getList()
    },
    handleCurrentChange (page) {
      this.param.page = page
      this.getList()
    },
    async addLectionDay (data) {
      const res = await this.$http.post('/admin/lection_day/add', data)
      if (res.code === 0) {
        this.closeDialog()
        this.getList()
      } else {
        this.$message.error(res.msg)
      }
    },
    async updateLectionDay (id, data) {
      const res = await this.$http.post('/admin/lection_day/update/' + id, data)
      if (res.code === 0) {
        this.closeDialog()
        this.getList()
      } else {
        this.$message.error(res.msg)
      }
    },
    showAddDialog () {
      this.addDialogAvaible = true
    },
    closeDialog () {
      this.addDialogAvaible = false
      this.currentId = 0
    },
    showEditDialog (id) {
      this.currentId = id
      this.showAddDialog()
    },
    deleteRow (id) {
      this.$confirm('是否真的要删除此记录?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const res = await this.$http.post('/admin/lection_day/delete/' + id)
        if (res.code === 0) {
          this.$message.success('删除成功')
          this.getList()
        } else {
          this.$message.error(res.msg)
        }
      }).catch(() => {})
    }
  }
}
</script>

<style>
</style>
